import React, { memo } from 'react';
import type { JSX } from 'react';

type ExperienceLogoProps = {
    color: string,
    height: number,
};

function ExperienceLogo(props: Readonly<ExperienceLogoProps>): JSX.Element {

    const originalWidth: number = 612;
    const originalHeight: number = 792;

    return (
        <svg
            version='1.1'
            id='Layer_1'
            xmlns='http://www.w3.org/2000/svg'
            x='0px'
            y='0px'
            viewBox='0 0 612 792'
            xmlSpace='preserve'
            width={originalWidth * (props.height / originalHeight)}
            height={props.height}
        >
            <g id='Experience'>
                <g className='st0'>
                    <path 
                        style={{
                            fill: props.color,
                        }}
                        d='M309,149.8c73.5,0,147,0,220.6,0c26.4,0,35.2,8.6,35.2,34.8c0,90.1,0,180.3,0,270.4c0,25.7-8.8,34.6-34.2,34.6
                            c-32.2,0-64.3,0.3-96.5-0.2c-8.7-0.1-11.6,2.5-11.5,11.4c0.5,30.4,0.1,60.8,0.2,91.2c0,7.7-0.2,15.5-9.1,18.3
                            c-8.8,2.8-13.5-3.3-18.3-9.3c-26.7-33.8-53.8-67.4-80.1-101.5c-5.9-7.7-12-10.1-21.3-10.1c-68.9,0.3-137.9,0.2-206.8,0.2
                            c-25.9,0-34.3-8.4-34.3-34.3c0-90.5,0-181,0-271.5c0-25.7,8.6-34.1,34.6-34.1C161.2,149.8,235.1,149.8,309,149.8z M302.3,427.3
                            c35.9-66.8,70.6-131.2,105.6-196.3c-12.3-6.6-23.1-12.4-34.8-18.6c-25.2,46.7-50,92.7-75.7,140.5c-18.1-24.7-34.7-47.3-51.7-70.4
                            c-11.1,8.1-21.2,15.5-31.7,23.2C243.6,346.3,272.1,385.7,302.3,427.3z'
                    />
                </g>
            </g>
        </svg>
    );
}

export default memo(ExperienceLogo);